import notification from 'antd/lib/notification';

notification.config({
  placement: 'bottomRight',
});

export { notification };
